import { render, staticRenderFns } from "./AppNav.vue?vue&type=template&id=477895f4&scoped=true&"
import script from "./AppNav.vue?vue&type=script&lang=ts&"
export * from "./AppNav.vue?vue&type=script&lang=ts&"
import style0 from "./AppNav.vue?vue&type=style&index=0&id=477895f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477895f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
